import Vue from 'vue'
import vmodal from 'vue-js-modal'
Vue.use(vmodal)



// WEBPACK FOOTER //
// ./src/plugins/vue-js-modal.js